// extracted by mini-css-extract-plugin
module.exports = {"alert":"CommonAlert_alert__JskJ7","close-btn":"CommonAlert_close-btn__v1XzR"};